import blogCard from "./blogCard"
export default blogCard;
